import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { BodyCopy } from 'secondstep-components'

export const Bullet = styled.span`
  display: inline-block;
  height: 0.8125rem;
  width: 0.8125rem;
  border-radius: 50%;
  background: ${themeGet('colors.yellow')};
  margin: 0 0.625rem 0.125rem;
`

export const Pipe = styled.span`
  margin: 0 0 0 0.5rem;
`

export const StyledBodyCopy = styled(BodyCopy)`
  font-size: 1.125rem;
  strong {
    font-family: ${themeGet('font.molde.medium')};
  }
`

export const StyledBodyCopyWithSpacing = styled(StyledBodyCopy)`
  margin-right: 0.25rem;
`

export const SubHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const TextRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.125rem 0 0.625rem;
`
